export const NAME = 'completeProfile';

export const PROFILE_COMPLETION_REWARD = 100;
